<template>
    <div class='page'>
        <div class="lf">
            第{{currentPage}}页 / 共{{Math.ceil(total/pageSize)}}页
        </div>
        <el-pagination
        class='rt'
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change='changePage'
        :total="total">
        </el-pagination>
    </div>
</template>
<script>
export default {
    name:'page',
    props:{
        currentPage:{
            type:Number
        },
        total:{
            type:Number
        },
        pageSize:{
            type:Number
        }
    },
    data(){
        return{

        }
    },
    methods:{
        changePage(value){
            this.$emit('changePage',value);
        }
    }
}
</script>
<style lang="less" scope>
    .page{
        padding:10px 0;
        .lf{
            line-height:32px;
            color:#333;
        }
    }
</style>